// Copyright (c) 2016 Deere & Company

import './option-item.scss';
import React, {PropTypes} from 'react';
import Option from '@deere/cps-it.warranty-model-factory/lib/option';
import {buildDate} from '../../../shared/services/build-date';

function handleOnClick() {

    this.onDelete(this.option.id);

}

const OptionItem = props =>
    <section className='option-item'>
        <div className='row'>
            <span className='option-code'>
                {props.option.optionCode}
            </span>
            <span className='description'>
                {props.option.description}
            </span>
            <span className='created'>
                {buildDate(props.option.createdDate)}
            </span>
            <span className='changed'>
                {buildDate(props.option.changedDate)}
            </span>
            <span className='changed-by'>
                {props.option.changedBy.id}
            </span>
            {props.option.canBeDeleted && props.canAddDeleteOption &&
                <span
                    className='icon-trash-can'
                    onClick={props::handleOnClick}
                />
            }
        </div>
    </section>;

OptionItem.displayName = 'OptionItem';
OptionItem.propTypes = {
    canAddDeleteOption: PropTypes.bool.isRequired,
    onDelete: PropTypes.func.isRequired,
    option: PropTypes.instanceOf(Option).isRequired
};

export default OptionItem;



// WEBPACK FOOTER //
// ./src/product/details/components/option-item.js